import { Box, Stack } from "@mui/material";
import { ObjectType } from "../../../Core/Api/Types/object-type";
import { useAppDispatch, useAppSelector } from "../../../Redux/redux-store";
import {
  DrivePanelState,
  GetIsSearch,
  GetPanelState,
  SetPanelState,
  ToggleEnlargePanel,
} from "../../../Redux/Reducers/redux-slice-drive";
import { GetTreeObj, TreeContext } from "../../../Redux/Reducers/redux-slice-tree";
import { DriveFolderContent } from "../Folders/drive-folder-content";
import { DriveFolderHeader } from "../Folders/drive-folder-header";
import { DriveEnlargedPanel } from "../Panels/drive-enlarged-panel";
import { DriveSearchHeader } from "../Search/drive-search-header";
import { DriveSearchContent } from "../Search/drive-search-content";
import { DriveFolderPanel } from "../Panels/drive-folder-panel";
import DriveTreeView from "../Folders/drive-treeview-panel";
import { cacheService } from "../../../Core/Api/services";
import { PreviewContext } from "../../../Pages/admin/Inventory/InventoryAssetSingle/AssetSinglePreview/asset-single-preview";
import { AssetPanel2 } from "../../Panels/AssetPanel/asset-panel-2";
import { DriveContext } from "./drive-navigate-handler";
import { use } from "react";

export const authorizedObjectOnPanel = [
  ObjectType.Video,
  ObjectType.VideoClip,
  ObjectType.Audio,
  ObjectType.Document,
  ObjectType.Subtitle,
  ObjectType.Image,
  ObjectType.Folder,
  ObjectType.GraphSkeleton,
];

export const DriveCenterPanel = (props) => {
  const { loadedChildrenCount, hasNextPage, loadingNextPageIndex = hasNextPage ? loadedChildrenCount : -1 } = props;
  const dispatch = useAppDispatch();

  // Redux
  const panelState = useAppSelector(GetPanelState);
  const enlargedPanel = panelState === DrivePanelState.Enlarged;
  const isSearch = useAppSelector(GetIsSearch);
  const headObjectId = use(DriveContext)?.headObjectId;

  return (
    <Box width="100%" height="100%">
      <Stack
        width={"100%"}
        height={enlargedPanel ? "auto" : "100%"}
        sx={(theme) => ({
          overflow: "hidden",
          transition: theme.transitions.create("all", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          position: "relative",
        })}
      >
        {enlargedPanel ? (
          <>
            <DriveFolderPanel />
            <DriveEnlargedPanel />
          </>
        ) : (
          <>
            {isSearch ? (
              <>
                <DriveSearchHeader />
                <DriveSearchContent />
              </>
            ) : (
              <>
                <DriveTreeView headObjectId={headObjectId} />
                <DriveFolderHeader />
                <DriveFolderContent />
              </>
            )}

            <AssetPanel2
              onClose={() => dispatch(SetPanelState(DrivePanelState.Closed))}
              toggleEnlargePanel={() => dispatch(ToggleEnlargePanel())}
              open={true}
              closable={false}
              context={PreviewContext.DriveFolderPreview}
            />
          </>
        )}
      </Stack>
    </Box>
  );
};
